module.exports = __webpack_public_path__ + "static/media/global-market.fa2022fb.svg";